const themeFunctions = {
	listenQtd: function(){
		document.querySelectorAll('.card-qtd').forEach((item) => {
			item.querySelector('button.minus').addEventListener("click", () => {
				let value = item.querySelector("input").value;
				
				if(value > 1){
					item.querySelector("input").value = parseInt(value)-1;
                    item.closest('.card__content').querySelector('.quick-add form input[name="quantity"]').value = parseInt(value)-1;
				}
			})
			
			item.querySelector('button.plus').addEventListener("click", () => {
				let value = item.querySelector("input").value;

                if(item.querySelector("input").getAttribute("max") >= parseInt(value)+1){
    				item.querySelector("input").value = parseInt(value)+1;
                    item.closest('.card__content').querySelector('.quick-add form input[name="quantity"]').value = parseInt(value)+1;
                }
			})
		})
	},

    scrollToEl: function(el){
      const contentSection = el.dataset.content;
      document.querySelector(`#content-${contentSection}`).scrollIntoView({
          behavior: 'smooth'
      });        
    },
	
	init: function(){
		this.listenQtd();

        document.querySelectorAll('#menu-about-us ul>li').forEach((li) => {
        	li.addEventListener("click", () => this.scrollToEl(li))
        })
	}
}

window.addEventListener("load", () => {
	themeFunctions.init();
})

const popPopup = {
  verificarCookie: function() {
      if (document.cookie.includes("popupFechado=true")) {
          fecharPopup(); 
      } else {
          setTimeout(mostrarPopup, 5000); 
      }
  },
  
  mostrarPopup: function() {
      var popup = document.querySelector("#myPopup .popup-content");
      popup.querySelector('.close-button').addEventListener('click', () => {
          this.fecharPopup();
      });

      document.addEventListener('click', (e) => {
        //Elemento-pai que será verificado
        if(!popup.contains(e.target)) {
          this.fecharPopup();
        }
      });
    
      document.querySelector('body').classList.add('show-popup');

      sessionStorage.setItem('popup-viewed', 'true');
  },

  fecharPopup: function() {
      document.querySelector('body').classList.remove('show-popup');
      //var dataExpiracao = new Date(new Date().getTime() + {{ settings.cookie_time }} * 10 * 1000); 
      //document.cookie = "popupFechado=true; expires=" + dataExpiracao.toUTCString();
  },

  init: function(){
      if(sessionStorage.getItem('popup-viewed') != "true"){
          this.mostrarPopup();
      }
  }
}

if(document.querySelector('body.home #myPopup') != null){
    popPopup.init();
}

const googleFormFunctions = {
  init: function(){
    const btnForm = document.querySelector('#open-form');
    
    if(btnForm){
    	const btnClose = document.querySelector("#google-form button.close");
    	
    	btnForm.addEventListener("click", () => {
    		document.querySelector("body").classList.add("open-google-form");
    	})
    	
    	btnClose.addEventListener("click", () => {
    		document.querySelector("body").classList.remove("open-google-form");
    	})
    }
  }
}

googleFormFunctions.init();